import HomeHeaderLogo from '@/pages/home/home-header/home-header-logo';
import { AppDownloadButton } from '@/utils/app-download-button';

export function Footer() {
    const navLinks = [
        { label: 'ΑΡΧΙΚΗ', link: '/' },
        { label: 'PADU APP', link: '/padu-app' },
        { label: 'ΣΧΕΤΙΚΑ', link: '/about' },
        { label: 'ΣΥΝΕΡΓΑΤΕΣ', link: '/partners' },
        { label: 'ΕΠΙΚΟΙΝΩΝΙΑ', link: '/contact' },
        { label: 'ΝΕΑ', link: '/ta-nea-mas' },
    ];

    const servicesLinks = [
        { label: 'PROMO', link: '/promo-and-rewards' },
        { label: 'LOYALTY', link: '/loyalty' },
        { label: 'BENEFITS', link: '/benefits' },
        { label: 'DIGITAL SIGNAGE', link: '/digital-signage' },
        { label: 'MUSIC', link: '/music-audio-messaging' },
        { label: 'RETAIL MEDIA', link: '/retail-media' },
    ];

    const socialItems = [
        {
            label: 'Facebook',
            link: 'https://www.facebook.com/paduapp/',
            icon: (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
            ),
        },
        {
            label: 'TikTok',
            link: 'https://www.tiktok.com/@padu_app',
            icon: (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                </svg>
            ),
        },
        {
            label: 'Instagram',
            link: 'https://www.instagram.com/padu_app/',
            icon: (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
            ),
        },
        {
            label: 'YouTube',
            link: 'https://www.youtube.com/@paduapp',
            icon: (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
            ),
        },
        {
            label: 'LinkedIn',
            link: 'https://www.linkedin.com/company/padu-app/',
            icon: (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
            ),
        },
    ];

    return (
        <footer className="bg-black text-white pt-16 pb-8 w-full relative">
            <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
                {/* Main Footer Content */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
                    {/* Logo and App Downloads */}
                    <div className="md:col-span-1 flex flex-col">
                        <div className="overflow-hidden">
                            <HomeHeaderLogo className="scale-80 mb-[-80px] h-[350px]" />
                        </div>
                        <AppDownloadButton />
                    </div>

                    {/* Πλοήγηση */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4 text-[#00d9d9]">ΓΕΝΙΚΑ</h3>
                        <ul className="space-y-2">
                            {navLinks.map((item) => (
                                <li key={item.link}>
                                    <a
                                        href={item.link}
                                        className="text-gray-400 hover:text-[#00d9d9] transition-colors text-sm block"
                                    >
                                        {item.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Υπηρεσίες */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4 text-[#00d9d9]">ΥΠΗΡΕΣΙΕΣ</h3>
                        <ul className="space-y-2">
                            {servicesLinks.map((item) => (
                                <li key={item.link}>
                                    <a
                                        href={item.link}
                                        className="text-gray-400 hover:text-[#00d9d9] transition-colors text-sm block"
                                    >
                                        {item.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Follow us */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4 text-[#00d9d9]">FOLLOW US!</h3>
                        <div className="flex flex-wrap gap-3">
                            {socialItems.map((item) => (
                                <a
                                    key={item.label}
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-10 h-10 flex-shrink-0 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#00d9d9]/20 transition-colors"
                                    aria-label={item.label}
                                >
                                    {item.icon}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="pt-8 border-t border-white/10">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-gray-400 text-sm">
                            Copyright © PADU 2026
                        </p>
                        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
                            <a href="/oroi-xrisis" className="text-gray-400 hover:text-[#00d9d9] transition-colors">
                                Όροι & Προϋποθέσεις
                            </a>
                            <a href="/politiki-aporritou" className="text-gray-400 hover:text-[#00d9d9] transition-colors">
                                Πολιτική Απορρήτου
                            </a>
                            <a href="/cookies" className="text-gray-400 hover:text-[#00d9d9] transition-colors">
                                Πολιτική Cookies
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}